export const getOrderTracking = ({ orderId }: { orderId: string }) => ({
	method: 'GET',
	url: `/wcs/resources/store/10001/tracking/${orderId}`,
});
